import { Bot, MessageCircle, Leaf, Users } from 'lucide-react';

export const projectsData = [
  {
    title: 'SENA – AI Chat Platform',
    description: 'A chatbot platform integrating the Gemini API for text-based conversational AI with a clean and modular architecture.',
    tech: ['React', 'Node.js', 'Gemini API'],
    image: '/images/sena.png',
    github: 'https://github.com/ryanazryan/sena.git',
    demo: 'https://senaeducation.com/'
  },
  {
    title: 'Zarashi – AI Chat Interface',
    description: 'A web-based chat interface connecting to external AI APIs, focused on simplicity and extensibility.',
    tech: ['React', 'TypeScript', 'API Integration'],
    image: '/images/zarashi.png',
    github: 'https://github.com/ryanazryan/zarashi.git',
    demo: 'https://zarashi.vercel.app/'
  },
  {
    title: 'Smart Garden – IoT Monitoring System',
    description: 'A smart garden monitoring application that displays environmental data for data-driven plant care.',
    tech: ['JavaScript', 'IoT Integration', 'Web Dashboard'],
    image: '/images/smartgarden.png',
    github: 'https://github.com/ryanazryan/smart_garden.git',
  },
  {
    title: 'Alumni ULM App',
    description: 'An Android app for browsing and searching alumni information, powered by Java and API integration.',
    tech: ['Java', 'Retrofit', 'RESTful API'],
    image: '/images/alumniulm.png',
    github: 'https://github.com/ryanazryan/alumni_ulm_app.git',
  },
  {
    title: 'Villaloka - Booking Hotel App',
    description: 'A responsive web app for discovering and booking vacation villas effortlessly.',
    tech: ['PHP', 'Bootstrap', 'MySQL', 'HTML', 'CSS', 'JavaScript'],
    image: '/images/villaloka.png',
    github: 'https://github.com/ryanazryan/villaloka.git',
  },
  {
    title: 'Wonderful Kalsel',
    description: 'A web-based platform showcasing tourism, culture, and local destinations in South Kalimantan with an informative and visual-focused layout.',
    tech: ['Web Development', 'JavaScript', 'UI Design'],
    image: '/images/wonderfulkalsel.png',
    github: 'https://github.com/ryanazryan/wonderful-kalsel.git',
  }
];

export const techStackData = [
  {
    category: 'Languages',
    items: ['JavaScript', 'TypeScript', 'PHP', 'Go', 'Java', 'Python']
  },
  {
    category: 'Frontend',
    items: ['React', 'Next.js', 'Vue', 'Tailwind CSS', 'Bootstrap']
  },
  {
    category: 'Backend',
    items: ['Node.js', 'Laravel', 'CodeIgniter', 'JWT Authentication']
  },
  {
    category: 'Databases',
    items: ['MySQL', 'PostgreSQL', 'Firebase']
  },
  {
    category: 'Cloud & Deployment',
    items: ['Vercel', 'Netlify', 'Nginx', 'Apache']
  },
  {
    category: 'AI / Integration',
    items: ['Gemini API']
  },
  {
    category: 'IoT',
    items: ['IoT Integration']
  },
  {
    category: 'Tools',
    items: ['Git', 'GitHub', 'GitLab', 'npm', 'Vite', 'Webpack', 'Postman', 'Socket.IO']
  },
  {
    category: 'Design',
    items: ['Figma', 'Blender', 'Canva']
  }
];